import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import Linkify from "~/components/Linkify";
import { ResizableEditableTextInput } from "~/components/ResizableEditableTextInput";
export const EditableContentHeaderDescription = /*#__PURE__*/ memo((param)=>{
    let { label, onSubmit, text, testId } = param;
    if (onSubmit) {
        return /*#__PURE__*/ _jsx("div", {
            className: "-ml-1 inline-flex",
            children: /*#__PURE__*/ _jsx(ResizableEditableTextInput, {
                "data-testid": testId,
                label: label,
                placeholder: "Click to add a description",
                defaultValue: text,
                onSubmit: onSubmit,
                appearance: "ghost",
                size: "small"
            })
        });
    }
    return /*#__PURE__*/ _jsx(Linkify, {
        children: /*#__PURE__*/ _jsx("p", {
            "data-testid": testId,
            "data-disableselect": "true",
            className: "whitespace-pre-wrap break-words text-14 text-grey-12",
            children: text
        })
    });
});
EditableContentHeaderDescription.displayName = "EditableHeaderDescription";
